import React from "react";
import { injectIntl } from "react-intl";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import { StyledF8 } from "../components/Account/AccountFormStyles";
import { getCourseState } from "../services/quiznator";
import _ from "lodash";
import TextF4 from "./TextF4";

import { injectCourseProgress } from "moocfi-quizzes";

const StyledF4 = styled(TextF4)`
  color: #29264c;
  margin: 0;
`;


class Ects extends React.Component {
  constructor() {
    super();
    this.state = {
      completed: false
    };
  }

  componentDidMount() {
    getCourseState().then(response => {
      const completed = _.get(response, "completion.completed", false) === true;

      this.setState({ completed });
    });
  }

  render() {
    const completed =
      this.props.courseProgressData && this.props.courseProgressData.completed;

    /*if (!completed) {
      return (
        <div>
          <StyledF4>
            <FormattedMessage id="account.credits" />
          </StyledF4>
          <StyledF8>
            <FormattedMessage id="ects.text" />
          </StyledF8>
        </div>
      );
    }*/

    /*return (
      <div>
        <StyledF4>
          <FormattedMessage id="account.credits" />
        </StyledF4>
        <StyledF8>
          <FormattedMessage id="ects.textCompleted" />
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={this.props.intl.formatMessage({ id: "routes.ects" })}
            style={{ color: "white" }}
          >
            <FormattedMessage id="ects.link" />
          </a>
        </StyledF8>
      </div>
    );*/

    return (
      <div>
        <StyledF4>
          <FormattedMessage id="account.credits" />
        </StyledF4>
        <StyledF8>
          <FormattedMessage id="ects.info" />{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={this.props.intl.formatMessage({ id: "routes.ects.faq" })}
            style={{ color: "#29264c", fontWeight:'bold' }}
          >
            <FormattedMessage id="ects.readMore" />
          </a>
        </StyledF8>
      </div>
    )
  }
}

export default injectIntl(injectCourseProgress(Ects));
